/**
 * @fileoverview Summary Cards Component
 * @description Top-level KPI cards for the Test Automation Leverage dashboard
 */

import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { FileText, FolderKanban, CheckCircle2, Clock } from 'lucide-react';

const StatCard = ({ icon: Icon, label, value, color }) => (
  <Paper
    elevation={0}
    sx={{
      p: 3,
      borderRadius: 3,
      border: '1px solid #E5E7EB',
      display: 'flex',
      alignItems: 'center',
      gap: 2,
      flex: 1,
      minWidth: 200,
    }}
  >
    <Box
      sx={{
        width: 48,
        height: 48,
        borderRadius: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: `${color}15`,
        color,
      }}
    >
      <Icon size={24} />
    </Box>
    <Box>
      <Typography variant="h5" sx={{ fontWeight: 700, color: '#1F2937' }}>
        {value}
      </Typography>
      <Typography variant="body2" sx={{ color: '#6B7280', fontWeight: 500 }}>
        {label}
      </Typography>
    </Box>
  </Paper>
);

const SummaryCards = ({ summary, testCases }) => {
  if (!summary) return null;

  const totalCount = summary.totalCount || 0;
  const projectCount = (summary.byProject || []).length;
  const designState = (summary.byState || {})['Design'] || 0;
  const readyState = (summary.byState || {})['Ready'] || 0;

  return (
    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 3 }}>
      <StatCard
        icon={FileText}
        label="Total Test Cases"
        value={totalCount}
        color="#0097A9"
      />
      <StatCard
        icon={FolderKanban}
        label="Projects"
        value={projectCount}
        color="#01426A"
      />
      <StatCard
        icon={CheckCircle2}
        label="Ready"
        value={readyState}
        color="#00AF66"
      />
      <StatCard
        icon={Clock}
        label="In Design"
        value={designState}
        color="#FFB81C"
      />
    </Box>
  );
};

export default SummaryCards;
